module.exports = __webpack_public_path__ + "static/fonts/ionicons.19e65b8.eot";


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/megamenu/fonts/ionicons.eot
// module id = iOQn
// module chunks = 0